var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-upload',{attrs:{"name":"file","multiple":false,"action":_vm.uploadUrl,"headers":_vm.headers,"before-upload":_vm.beforeUpload},on:{"change":_vm.handleChange}},[_c('a-button',[_c('a-icon',{attrs:{"type":"upload"}}),_vm._v(" Click to Upload ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }